export enum EBroadcastChannelMessageType {
  UserUnauthorize = 'user_unauthorize',
}

export interface IBroadcastChannelMessageEvent {
  type: EBroadcastChannelMessageType;
}
